const data = {
  id: 1,
  title: 'Listen and choose the correct word.  ',
  subTitle: '(Nghe và chọn từ đúng)',
  audioUrl: 'https://cloud.softech.cloud/storage/Data/Sentences/f95b3fd4-2c96-4df8-8f31-1dfe7acf6c72.mp3',
  answers: [
    { id: 1, answer: 'hippo ', isCorrect: false },
    { id: 2, answer: 'crocodile', isCorrect: true },
    { id: 3, answer: 'bear', isCorrect: false },
  ],
  settings: {
    answers: {
      direction: 'horizontal',
      bulletType: 'none',
      // bulletType: 'character',
      // bulletType: 'number',
    },
  },
};

export default data;
